// object > Actions > TagApplication(Create/Edit/View)
(function() {
    'use strict';

    var TagApplicationCtrl = function($scope, $timeout, xmsNotificationFactory, $uibModalInstance, passedModel) {

        if (!angular.isDefined(passedModel)) {
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }
        $scope.xmsNotifications = xmsNotificationFactory;

        $scope.formModel = {};
        $scope.pageModel = {};
        $scope.ngModel   = passedModel;
        $scope.pageModel.showCertify = $scope.ngModel.certified;

        $scope.ok = function() {
            $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
        };

        $scope.cancel = function(e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        $scope.initCertify = function(value) {
            $scope.pageModel.showCertify = value;
        }

        var loadedWatch = $scope.$watch("loaded", function(newVal, oldVal) {
            if (newVal === true) { // first ng-include load
                loadedWatch(); // cancel this watch
            }
        });


        $scope.submitForm = function(e) {
            $scope.disableSubmit = true;
            e.preventDefault();
            var options = {
                beforeSubmit: showRequest, // this function is in the editInner.gsp template
                complete: showResponse // this function is in the editInner.gsp template
            };
            // we use jquery.form as this needs to handle file upload (until better method is developed)
            // (it can be done ajax way now - needs jira for this)
            $('#formEdit').ajaxSubmit(options);
        }

        $scope.closeAndTableRefresh = function(e) {
            this.ngModel.smartTableRefreshCounter++;

            $scope.xmsNotifications.add('closeAndTableRefreshMsg', 'success', 'Document successfully uploaded.', 5);

            $uibModalInstance.close(this.ngModel);
            e.preventDefault();
        }


        // used for warnings for date from fields where the date must not be before the current date
        $scope.currentDate = function() {
            return new Date();
        };

        $scope.sixMonthsFromSelectedDate = function(originalDate) {
          if( $scope.formModel.editable === true){
            var newDate = new Date(originalDate);
            newDate.setMonth(newDate.getMonth() + 6);
            $scope.formModel.tagToDate = newDate;
          }
        };

        $scope.oneYearValidationDate = function() {
            var validationDate = new Date();
            validationDate.setYear(validationDate.getFullYear() + 1)
            return validationDate;
        };

      $scope.setupTagDateWatch = function(watchKey) {
        const applicationRegistrationCard = '2505'; //Application Registration Card with positive ECS result
        const positiveVerificationNotice = '2513'; //Positive Verification Notice from Employer Checking Service (ECS)

        $scope.$watchCollection(watchKey, function(selectedOptions) {
          let noOfSelectedOptions = Object.values(selectedOptions || {}).filter(function(v) { return v === true; }).length;

          if ($scope.formModel.tagApplicationOption && noOfSelectedOptions === 0) {
            $scope.formModel.tagToDate = null;
          }

          if (selectedOptions && (selectedOptions[applicationRegistrationCard] || selectedOptions[positiveVerificationNotice])) {
            let futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            $scope.formModel.tagToDate = futureDate;
          }
        });
      };

        // End For Tag Application
    };
    TagApplicationCtrl.$inject = ['$scope', '$timeout', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('TagApplicationCtrl', TagApplicationCtrl);
}());
